/**
 * Normalizes any reasonable Ukrainian phone number input into +380XXXXXXXXX.
 * Implemented once here per AGENTS.md §6.10 and imported from apps/web and every Worker
 * (Workers can bundle this package directly since everything runs through esbuild/wrangler).
 *
 * Rules (exact cases from AGENTS.md §6.10):
 *   0501234567    (10 digits, leading 0)   -> +380501234567
 *   380501234567  (12 digits, no plus)     -> +380501234567
 *   +380501234567                          -> unchanged
 *   501234567     (9 digits, no leading 0) -> +380501234567
 *   anything else: strip non-digits, prefix '+', best effort (do not crash).
 */
export function normalizePhone(input: string): string {
  const digits = (input ?? "").replace(/\D/g, "");

  if (digits.length === 10 && digits.startsWith("0")) {
    return `+380${digits.slice(1)}`;
  }
  if (digits.length === 12 && digits.startsWith("380")) {
    return `+${digits}`;
  }
  if (digits.length === 9) {
    return `+380${digits}`;
  }
  // Best effort fallback: keep whatever digits we found, don't throw.
  return digits ? `+${digits}` : "";
}

/** True if a normalized phone looks like a plausible +380XXXXXXXXX number. */
export function isValidUaPhone(phone: string): boolean {
  return /^\+380\d{9}$/.test(phone);
}
